










import { Component, Prop, Vue } from 'vue-property-decorator'
import User from '@/users/entities/user'

@Component
export default class UserStatusBadge extends Vue {
  @Prop({ required: true })
  private user!: User
}
